import { TabSync } from '@rocketlane/state-db';
import { logger } from 'services';
/**
 * ONE channel for every collection — messages carry their own `c` (collection
 * id), so a second channel would only add another structured-clone target and a
 * second presence handshake.
 *
 * Not account-scoped in the NAME on purpose: the channel outlives an account
 * switch, and re-creating it per account would leave the old instance open in
 * whichever tab had not switched yet. The `accountId`/`userId` guard inside the
 * envelope is what actually isolates principals — see `TabSync.receive`.
 */ const CHANNEL_NAME = 'rl:state-db';
/**
 * Read at both send and receive time. Mutable module state rather than a
 * constructor argument because identity changes underneath a long-lived tab
 * (login, logout, account switch) and the guard is only meaningful if it
 * reflects the CURRENT session, not the one that existed at construction.
 */ let identity = {
    accountId: null,
    userId: null
};
let instance = null;
export const setTabSyncIdentity = (next)=>{
    identity = next;
};
/** The shared cross-tab channel, created on first use. */ export const getTabSync = ()=>{
    if (!instance) {
        instance = new TabSync({
            channelName: CHANNEL_NAME,
            getIdentity: ()=>identity,
            onError: (error, context)=>logger.error(`state-db tab-sync failed: ${context}`, {
                    error
                })
        });
    }
    return instance;
};
/** Tear the channel down (logout). A later `getTabSync()` builds a fresh one. */ export const closeTabSync = ()=>{
    instance === null || instance === void 0 ? void 0 : instance.close();
    instance = null;
};
